import React from "react";
import { Table } from "react-bootstrap";

import { useCoiContext } from "../contexts/Coi";

import { defaultDateFormat } from "../../../../../lib/utils";

const COIInfo = (): React.JSX.Element => {
    const { coi } = useCoiContext();

    return coi ? (
        <Table className="coiInfoTable" data-testid="coiInfoTable">
            <thead>
                <tr>
                    <th>File Name</th>
                    <th>Upload Date</th>
                    <th>Status</th>
                    <th>
                        {coi.status === "Rejected" ? "Rejection" : "Approval"}{" "}
                        Date
                    </th>
                    {coi.status === "Rejected" && <th>Reason</th>}
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{coi.file}</td>
                    <td>
                        {defaultDateFormat.format(new Date(coi.uploadDate))}
                    </td>
                    <td>{coi.status}</td>
                    <td>
                        {coi.approvalDate &&
                            defaultDateFormat.format(
                                new Date(coi.approvalDate),
                            )}
                    </td>
                    {coi.status === "Rejected" && <td>{coi.message}</td>}
                </tr>
            </tbody>
        </Table>
    ) : (
        <></>
    );
};

export default COIInfo;
